import { queryFilter } from '../../hooks/useQueryFilters';
import type { LeadPersonaType, LeadTemperatureType } from '../../types';

export const COMMERCIAL_QUERY_FILTER_SCHEMA = {
  page: queryFilter.integer(1, { min: 1 }),
  searchName: queryFilter.string(),
  classifications: queryFilter.array<string>(),
  leadTemperatureTypes: queryFilter.array<LeadTemperatureType>(),
  personaTypes: queryFilter.array<LeadPersonaType>(),
  cancellationReasons: queryFilter.array<string>(),
  investmentInterests: queryFilter.array<string>(),
  startTimeExpectations: queryFilter.array<string>(),
  mainGoals: queryFilter.array<string>(),
  commercialStages: queryFilter.array<string>(),
  paidStatuses: queryFilter.array<string>(),
  paymentMethods: queryFilter.array<string>(),
  joinedAtStart: queryFilter.string(),
  joinedAtEnd: queryFilter.string(),
  projectCodes: queryFilter.array<string>(),
  commercialOwnerIds: queryFilter.array<string>(),
};
